import '../../tables/Table.module.css'
function CampaignValidationTable(props) {

    const colNames =  ['validation error', 'please correct'];   
    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                {colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);

    let tableRows = (<></>);
    tableRows = props.validationMessage.map((msg, id) => (
        <tr key={`row_${id}`}>
            <td key={`err_msg_${id}`} style={{verticalAlign: 'top'}}>
                <div style={{ fontSize: '14px', color: 'red'}}>
                    {msg.msg}
                </div>
            </td>
            <td key={`correct_${id}`} style={{verticalAlign: 'top'}}>
            <button 
                id={`correct_${id}`}
                // className={'actionButtonTiny'}
                className={'cellButton'}
                style={{marginTop:'3px', marginBottom:'3px', width:'130px'}}
                onClick={msg.action} >
                validate in editor
            </button>
            </td>
        </tr>
    ));





    return(<>
        <table style={{ tableLayout: 'auto' }}>
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default CampaignValidationTable;
